import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead, MDBContainer, MDBRow, MDBCol, MDBBtn, MDBInput } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit, faBarcode, faGear } from '@fortawesome/free-solid-svg-icons'
import HeaderTabla from '../../componentes/HeaderTabla'
import { NumericFormat } from 'react-number-format';
import PeticionTraeDatos from '../../hooks/useTraeDatos';

const baseUrl = process.env.REACT_APP_BASE_URL
const api = process.env.REACT_APP_API
const urlConfiguraciones = baseUrl + api + 'configuraciones/'


const VerProductos = ({ data, imprimeArray, seleccionaProducto, baseUrl }) => {
	const [configuraciones] = PeticionTraeDatos(urlConfiguraciones)
	const dataConfiguracion = configuraciones ? configuraciones[16] : [];
	const alerta = dataConfiguracion ? JSON.parse(dataConfiguracion.valor) : []



	const Estado = (producto) => {
		let colorNotificacion = ''
		let textoNotificacion = ''

		if (producto.inventario === 'true') {

			if (parseInt(producto.alerta) > 0) {
				if (parseInt(producto.alerta) >= parseInt(producto.inventarioCantidad)) {
					textoNotificacion = 'Por Agotarse'
					colorNotificacion = 'Rojo'

				} else {
					textoNotificacion = 'Con existencias'
					colorNotificacion = 'Verde'
				}
			} else {
				let Agota = alerta[0] // tiene rangofin
				let PocasExis = alerta[1]
				let EnExis = alerta[2] //tiene rangoini

				let sumarInventario = parseInt(producto.inventarioCantidad)

				if (sumarInventario < parseInt(Agota?.rangofin)) {
					textoNotificacion = 'Agotado'
					colorNotificacion = 'Rojo'
				} else if (sumarInventario >= parseInt(PocasExis?.rangoini) && sumarInventario <= parseInt(PocasExis?.rangofin)) {
					textoNotificacion = 'Pocas Existencias'
					colorNotificacion = 'Amarillo'
				} else if (sumarInventario >= parseInt(EnExis?.rangoini)) {
					textoNotificacion = 'En Existencia'
					colorNotificacion = 'Verde'
				}
			}

		}

		return {
			colorNotificacion,
			textoNotificacion
		}

	}

	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['', 'Referencia', 'Imagen', 'Producto', 'Categorías', 'Precio', 'Inventario', '']} />
				<MDBTableBody>

					{data.map((item, index) => {
						let inventarioCantidad = item.inventario == "true" ? item.inventarioCantidad : null

						let ArrayCategorias = item.categoria_producto
						const { colorNotificacion, textoNotificacion } = Estado(item)

						return (

							<tr key={index} className="tabla_productos">
								<td><div className={item.activo ? "bola_estado_activo" : "bola_estado_desact"}></div></td>
								<td>{item.referencia}</td>
								<td><div className="ImgProducto"><img src={`${baseUrl}${item?.url_imagen[0]?.nombre_imagen}`} /></div></td>
								<td>{`${item.nombre_producto} ${item.nombre_Atributo !== null ? '- ' + item.nombre_Atributo : ''}`}</td>
								<td>{imprimeArray(ArrayCategorias, true)}</td>
								<td><NumericFormat displayType="text" value={item.precio_rebajado > 0 ? item.precio_rebajado.toString() : item.precio_producto.toString()} prefix={'$'} thousandSeparator={true} /></td>
								<td className='text-center'> {inventarioCantidad ? <div className={`${colorNotificacion} notificacion`}>{inventarioCantidad}</div> : item.combo == "true" && item.inventario == "false" ? <div className={`Verde notificacion`}>Combo</div> : null} </td>

								<td className="tabla_funciones">
									<div className="col text-center">
										<button
											onClick={seleccionaProducto(item, 'editar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faEdit} size="lg" />
										</button>

										<button
											onClick={seleccionaProducto(item, 'eliminar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faTrashAlt} size="lg" />
										</button>

									</div>

								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerProductos